(function() {
    angular
        .module("globalArrowBoardMapModule")
        .config(globalArrowBoardMapRouter)

        globalArrowBoardMapRouter.$inject = [
        "$stateProvider",
        "$urlRouterProvider",
        "$locationProvider"
    ]

    function globalArrowBoardMapRouter(
        $stateProvider,
        $urlRouterProvider,
        $locationProvider
    ){
        $stateProvider
        .state("global-arrow-board-map", {
            url: "/global-arrow-board-map",
            templateUrl: "app/components/global-arrow-board-map/global-arrow-board-map.view.html",
            controller : "globalArrowBoardMapController"
        })


        .state("global-arrow-board-map.map", {
            url: "/map",
            views: {
                "device_details": {
                    templateUrl: "app/components/global-arrow-board-map/map.view.html",
                    controller : "globalArrowBoardMapController"
                }
            }
        })


        $urlRouterProvider.otherwise("/")

        $locationProvider.html5Mode(true)
    }
})()
